// ---- Klaviyo Form Specifics
window.addEventListener('DOMContentLoaded', () => {

  klaviyoNewsletterPopupSpecificsWrapper();

  function klaviyoNewsletterPopupSpecificsWrapper(){

    // --------- Modal triggers ---------
    document.body.addEventListener("click", function klaviyoNewsletterPopupWrapper(eventClick){
        // ---------------------------------------------------------------------
        // ----* For a new modal window change the name of the function above, add new IDs and attributes for the variables
        // theModalID,theTriggersAttributeValue and the same ones for the Window ID and their Close and Open trigger buttons
        const theModalID = document.getElementById("klaviyoNewsletterPopup");
        const theTriggersAttributeValue = "klaviyo-newsletter-popup";
        // ----*
        // ---------------------------------------------------------------------

        let openModal = eventClick.target.getAttribute("global_popup_modal_open");
        let closeModal = eventClick.target.parentNode.getAttribute("global_popup_modal_close");
                
        const modalInner = document.getElementById("global__popup__modal__overlay");
        let clickInside = modalInner.contains(eventClick.target);

        if(openModal == theTriggersAttributeValue){
            theModalID.classList.add("global__popup-modal--show");
            theModalID.classList.remove("global__popup-modal--hide");
        }
        if(closeModal == theTriggersAttributeValue){
            theModalID.classList.remove("global__popup-modal--show");
            theModalID.classList.add("global__popup-modal--hide");
        }
        // close modal from anywhere outside
        if (clickInside) {
            theModalID.classList.remove("global__popup-modal--show");
            theModalID.classList.add("global__popup-modal--hide");
        }
    });
    // --------- Modal triggers ---------

    // ----------Check if new user visited---------
    klaviyoNewsletterPopupCheckNewUser();
      
    function klaviyoNewsletterPopupCheckNewUser() {
        const theModalID = document.getElementById("klaviyoNewsletterPopup");
        const currentDate = new Date();
        const currentTime = currentDate.getTime();
      
        function isMoreThan24HourAgo(date) {
            const twentyFourHrInMs = 24 * 60 * 60 * 1000;
            const twentyFourHoursAgo = Date.now() - twentyFourHrInMs;
            return date < twentyFourHoursAgo;
        } 
  
        // if visited before
        if (localStorage.getItem("klavi_pop_newslet_visited") != null && getCookie('klavi_pop_newslet_close__co') == null && isMoreThan24HourAgo(localStorage.getItem("klavi_pop_newslet_vis_date")) == true) {
          setTimeout(function(){
            theModalID.classList.add("global__popup-modal--show");
            theModalID.classList.remove("global__popup-modal--hide");
          }, 2000);
        } 
        // if new visit
        else { 
          localStorage.setItem("klavi_pop_newslet_visited", "true");
  
          if(localStorage.getItem("klavi_pop_newslet_vis_date") == null) {
            localStorage.setItem("klavi_pop_newslet_vis_date", new Date());
          }
        } 
    }
    // ------------Check if new user visited END-------

    // ---------Check if modal has been closed recently--------
    document.body.addEventListener('click', function(eventClicked) {
      onCloseCreateCookie(eventClicked);
    });

    function onCloseCreateCookie(eventClicked) {
      let closeModal = eventClicked.target.parentNode.getAttribute("global_popup_modal_close");
      const theTriggersAttributeValue = "klaviyo-newsletter-popup";
      const modalInner = document.getElementById("global__popup__modal__overlay");
      let clickInside = modalInner.contains(eventClicked.target);

      if(closeModal == theTriggersAttributeValue){
        setCookie('klavi_pop_newslet_close__co','closed',100);
      }
      // close modal from anywhere outside
      if (clickInside) {
        setCookie('klavi_pop_newslet_close__co','closed',100);
      }
    }
    // ---------Check if modal has been closed recently END-------

    // -----------Cookies functions---------
    function setCookie(name,value,days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    function eraseCookie(name) {   
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
    // -----------Cookies functions END----------

  }

});
// ---- Klaviyo Form Specifics END